import styled from 'styled-components';

import { theme } from 'assets/styles/theme';
import { LoadingContainer } from 'components/containers/Containers';
import { LoadingIndicator } from 'components/ui-elements/LoadingIndicator';
import { useCurrentUser } from 'providers/cache/cachedDataHooks';

import { UserDetails } from './UserDetails';
import { UserPhoto } from './UserPhoto';

const Container = styled.div`
  display: flex;
  max-width: 960px;
  margin-top: 48px;

  ${theme.mq.tablet} {
    flex-direction: column;
  }
`;

export const AccountSettings = () => {
  const { currentUser, refreshCurrentUser } = useCurrentUser();

  if (!currentUser) {
    return (
      <LoadingContainer>
        <LoadingIndicator />
      </LoadingContainer>
    );
  }

  return (
    <Container data-testid={'account-settings'}>
      <UserPhoto userImage={currentUser.imageUrl!} />
      <UserDetails currentUser={currentUser} refreshCurrentUser={refreshCurrentUser} />
    </Container>
  );
};
